// Clients only. Shared table methods are in tableMixin.js.
export default {
    name: "Clients",
    methods: {
        // After the table loads: total cost and how many clients are online (tableMixin calls this)
        afterFetch(response) {
            this.tableData.totalCost = response.data.results.totalCost;
            this.tableData.clientsOnline = response.data.results.clientsOnline || { online: 0, total: 0 };
        },
        async handleUpdatePlanSuccess(response) {
            const clientId = this.formInputs.id; // the client whose plan changed: its row blinks
            this.defaultAlert.submitingSavingRecord = false;
            this.handleAlert("ending", response.data.message[0], "success", "page");
            this.$hideModal("planModal");
            await this.fetchRecords();
            this.flashRow(clientId); // tableMixin
        },
        handleFetchPlansSuccess(response) {
            this.plansOptions = response.data.results;
        },
    },
};